import { INotificationStore } from './notification.interface';

export const notificationInitialState: INotificationStore = {
  queue: [],
};
